(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fizzo-antes-despues"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.adListo) return;
    raiz.dataset.adListo = 'true';

    var comparador = raiz.querySelector('[data-ad-comparador]');
    var perilla = raiz.querySelector('[data-ad-perilla]');
    if (!comparador || !perilla) return;

    var inicial = parseFloat(raiz.dataset.inicial) || 50;
    var pos = inicial;
    var tocado = false;
    var arrastrando = false;
    var movido = false;
    var intro = null;

    function fijar(valor) {
      pos = Math.max(0, Math.min(100, valor));
      comparador.style.setProperty('--ad-pos', pos + '%');
      perilla.setAttribute('aria-valuenow', Math.round(pos));
      raiz.classList.toggle('antes-despues-fizzo--sin-antes', pos < 18);
      raiz.classList.toggle('antes-despues-fizzo--sin-despues', pos > 82);
    }

    function desdeEvento(e) {
      var r = comparador.getBoundingClientRect();
      fijar(((e.clientX - r.left) / r.width) * 100);
    }

    function cortarIntro() {
      tocado = true;
      if (intro) {
        window.cancelAnimationFrame(intro);
        intro = null;
      }
    }

    comparador.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      cortarIntro();
      arrastrando = true;
      movido = false;
      if (e.pointerType === 'mouse') {
        desdeEvento(e);
        raiz.classList.add('antes-despues-fizzo--arrastrando');
        try { comparador.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    comparador.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      movido = true;
      desdeEvento(e);
    });
    function soltar(e) {
      if (!arrastrando) return;
      if (e && e.type === 'pointerup' && !movido) desdeEvento(e);
      arrastrando = false;
      raiz.classList.remove('antes-despues-fizzo--arrastrando');
    }
    comparador.addEventListener('pointerup', soltar);
    comparador.addEventListener('pointercancel', function () {
      arrastrando = false;
      raiz.classList.remove('antes-despues-fizzo--arrastrando');
    });
    comparador.addEventListener('dragstart', function (e) { e.preventDefault(); });

    perilla.addEventListener('keydown', function (e) {
      var paso = e.shiftKey ? 10 : 5;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { fijar(pos - paso); e.preventDefault(); cortarIntro(); }
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { fijar(pos + paso); e.preventDefault(); cortarIntro(); }
      if (e.key === 'Home') { fijar(0); e.preventDefault(); cortarIntro(); }
      if (e.key === 'End') { fijar(100); e.preventDefault(); cortarIntro(); }
    });

    fijar(inicial);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (raiz.dataset.intro !== 'true' || reduce || !('IntersectionObserver' in window)) return;

    function suavizar(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animarIntro() {
      var tramos = [
        { desde: inicial, hasta: 22, ms: 700 },
        { desde: 22, hasta: 78, ms: 1000 },
        { desde: 78, hasta: inicial, ms: 700 }
      ];
      var indice = 0;
      var comienzo = null;
      function cuadro(t) {
        if (tocado) return;
        if (comienzo === null) comienzo = t;
        var tramo = tramos[indice];
        var avance = Math.min(1, (t - comienzo) / tramo.ms);
        fijar(tramo.desde + (tramo.hasta - tramo.desde) * suavizar(avance));
        if (avance >= 1) {
          indice++;
          comienzo = null;
          if (indice >= tramos.length) { intro = null; return; }
        }
        intro = window.requestAnimationFrame(cuadro);
      }
      intro = window.requestAnimationFrame(cuadro);
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting && !tocado) {
          observador.disconnect();
          setTimeout(function () { if (!tocado) animarIntro(); }, 300);
        }
      });
    }, { threshold: 0.6 });
    observador.observe(comparador);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-antes-despues-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-carrito"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = null;
  var ultimoFoco = null;

  function rutas() {
    var r = window.routes || {};
    var base = r.cart_url || '/cart';
    return {
      agregar: (r.cart_add_url || '/cart/add') + '.js',
      cambiar: (r.cart_change_url || '/cart/change') + '.js',
      carrito: base + '.js'
    };
  }

  function seccionId() {
    return raiz ? raiz.dataset.seccionId : null;
  }

  function formatear(centavos) {
    var simbolo = raiz && raiz.dataset.simbolo ? raiz.dataset.simbolo : '$';
    return simbolo + Math.round(centavos / 100).toLocaleString('es-AR');
  }

  function escribirMensaje(el, plantilla, monto) {
    el.textContent = '';
    var partes = plantilla.split('[monto]');
    partes.forEach(function (parte, i) {
      el.appendChild(document.createTextNode(parte));
      if (i < partes.length - 1) {
        var fuerte = document.createElement('strong');
        fuerte.textContent = monto;
        el.appendChild(fuerte);
      }
    });
  }

  function actualizarBarra(carrito) {
    if (!raiz || !carrito) return;
    var contador = raiz.querySelector('[data-cc-cantidad]');
    if (contador) contador.textContent = carrito.item_count;
    var caja = raiz.querySelector('[data-cc-envio]');
    if (!caja) return;
    var umbral = parseInt(caja.dataset.umbral, 10) || 0;
    if (!umbral) return;
    var total = carrito.total_price || 0;
    var falta = Math.max(0, umbral - total);
    var porcentaje = Math.min(100, Math.round((total * 100) / umbral));
    var texto = caja.querySelector('[data-cc-envio-texto]');
    var relleno = caja.querySelector('[data-cc-relleno]');
    var barra = caja.querySelector('[data-cc-barra]');
    caja.classList.toggle('carrito-fizzo__envio--logrado', falta === 0);
    if (relleno) relleno.style.width = (falta === 0 ? 100 : porcentaje) + '%';
    if (barra) barra.setAttribute('aria-valuenow', falta === 0 ? 100 : porcentaje);
    if (texto) {
      if (falta > 0) {
        escribirMensaje(texto, caja.dataset.textoFalta || '', formatear(falta));
      } else {
        texto.textContent = caja.dataset.textoLogrado || '';
      }
    }
  }

  function leerCarrito() {
    return fetch(rutas().carrito, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { actualizarBarra(carrito); return carrito; })
      .catch(function () {});
  }

  function abrir() {
    if (!raiz) return;
    ultimoFoco = document.activeElement;
    raiz.classList.add('carrito-fizzo--abierto');
    var panel = raiz.querySelector('[data-cc-panel]');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var cerrarBtn = raiz.querySelector('.carrito-fizzo__cerrar');
    if (cerrarBtn) setTimeout(function () { cerrarBtn.focus(); }, 350);
    leerCarrito();
  }

  function cerrar() {
    if (!raiz) return;
    raiz.classList.remove('carrito-fizzo--abierto');
    var panel = raiz.querySelector('[data-cc-panel]');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  function refrescar(html) {
    if (!raiz || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('[data-cc-contenido]');
    var actual = raiz.querySelector('[data-cc-contenido]');
    if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
  }

  function avisar() {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { origen: 'carrito-fizzo' } }));
  }

  function mostrarError(texto) {
    if (!raiz) return;
    var caja = raiz.querySelector('[data-cc-error]');
    if (!caja) return;
    caja.textContent = texto || 'No pudimos actualizar el carrito. Probá de nuevo.';
    caja.hidden = false;
    setTimeout(function () { caja.hidden = true; }, 5000);
  }

  function pedir(url, cuerpo, esFormData) {
    raiz.classList.add('carrito-fizzo--cargando');
    var opciones = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (esFormData) {
      opciones.body = cuerpo;
    } else {
      opciones.headers['Content-Type'] = 'application/json';
      opciones.body = JSON.stringify(cuerpo);
    }
    return fetch(url, opciones)
      .then(function (r) { return r.json(); })
      .finally(function () { raiz.classList.remove('carrito-fizzo--cargando'); });
  }

  function despuesDeCambio(respuesta) {
    var id = seccionId();
    if (respuesta && respuesta.sections && respuesta.sections[id]) refrescar(respuesta.sections[id]);
    avisar();
    return leerCarrito();
  }

  function saltito(el) {
    if (!el || !el.animate) return;
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(0.95)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
  }

  function volar(form, fin) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var destino = document.querySelector('.encabezado-fizzo__carrito, [data-abrir-carrito]');
    if (!raiz || raiz.dataset.vuelo !== 'true' || reduce || !destino || !document.body.animate) { fin(); return; }
    var rd = destino.getBoundingClientRect();
    if (!rd.width) { fin(); return; }
    var contenedor = form.closest('[data-compra-fizzo]') || document;
    var imagen = contenedor.querySelector('.compra-fizzo__imagen');
    var origen;
    var boton = form.querySelector('[type="submit"]');
    if (imagen) {
      var ri = imagen.getBoundingClientRect();
      if (ri.bottom > 0 && ri.top < window.innerHeight && ri.width) origen = ri;
    }
    if (!origen && boton) {
      var rb = boton.getBoundingClientRect();
      origen = { left: rb.left + rb.width / 2 - 45, top: rb.top + rb.height / 2 - 45, width: 90, height: 90 };
    }
    if (!origen || !imagen) { fin(); return; }
    var clon = document.createElement('img');
    clon.src = imagen.currentSrc || imagen.src;
    clon.alt = '';
    clon.className = 'carrito-fizzo-volador';
    clon.style.left = origen.left + 'px';
    clon.style.top = origen.top + 'px';
    clon.style.width = origen.width + 'px';
    clon.style.height = origen.height + 'px';
    document.body.appendChild(clon);
    var dx = rd.left + rd.width / 2 - (origen.left + origen.width / 2);
    var dy = rd.top + rd.height / 2 - (origen.top + origen.height / 2);
    var escala = Math.max(0.08, 40 / origen.width);
    var animacion = clon.animate([
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', borderRadius: '16px', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 140) + 'px) scale(' + (escala + 0.35) + ') rotate(-12deg)', borderRadius: '40%', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + escala + ') rotate(0deg)', borderRadius: '50%', opacity: 0.7 }
    ], { duration: 800, easing: 'cubic-bezier(0.45, 0, 0.25, 1)' });
    animacion.onfinish = function () {
      clon.remove();
      saltito(destino);
      setTimeout(fin, 180);
    };
  }

  function agregarDesdeForm(form) {
    var id = seccionId();
    var boton = form.querySelector('[type="submit"]');
    if (boton) boton.setAttribute('aria-busy', 'true');
    var datos = new FormData(form);
    datos.append('sections', id);
    datos.append('sections_url', window.location.pathname);
    pedir(rutas().agregar, datos, true)
      .then(function (r) {
        if (r.status) {
          mostrarError(r.description || r.message);
          abrir();
          return;
        }
        despuesDeCambio(r);
        volar(form, abrir);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
  }

  function iniciar(r) {
    if (!r || r.dataset.ccListo) return;
    r.dataset.ccListo = 'true';
    raiz = r;

    raiz.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-cerrar]')) { cerrar(); return; }
      var accion = e.target.closest('[data-cc-accion]');
      if (!accion) return;
      var id = seccionId();
      var tipo = accion.dataset.ccAccion;
      var peticion;
      if (tipo === 'quitar') {
        peticion = pedir(rutas().cambiar, { line: parseInt(accion.dataset.linea, 10), quantity: 0, sections: [id], sections_url: window.location.pathname });
      } else if (tipo === 'cambiar') {
        peticion = pedir(rutas().cambiar, { line: parseInt(accion.dataset.linea, 10), quantity: Math.max(0, parseInt(accion.dataset.cantidad, 10) || 0), sections: [id], sections_url: window.location.pathname });
      } else if (tipo === 'agregar') {
        peticion = pedir(rutas().agregar, { items: [{ id: parseInt(accion.dataset.variante, 10), quantity: 1 }], sections: [id], sections_url: window.location.pathname });
      }
      if (!peticion) return;
      peticion.then(function (res) {
        if (res.status) { mostrarError(res.description || res.message); return; }
        despuesDeCambio(res);
      }).catch(function () { mostrarError(); });
    });
  }

  document.addEventListener('click', function (e) {
    if (!raiz || raiz.dataset.abrirEncabezado !== 'true') return;
    var disparador = e.target.closest('.encabezado-fizzo__carrito, [data-abrir-carrito]');
    if (!disparador) return;
    e.preventDefault();
    abrir();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!raiz || !form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;
    if (form.querySelector('[name="return_to"]')) return;
    e.preventDefault();
    agregarDesdeForm(form);
  }, true);

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.origen === 'carrito-fizzo') return;
    leerCarrito();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && raiz && raiz.classList.contains('carrito-fizzo--abierto')) cerrar();
  });

  function iniciarTodos() {
    var r = document.querySelector('[data-carrito-fizzo]');
    if (r) iniciar(r);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', function () {
    raiz = null;
    iniciarTodos();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (raiz && e.detail && e.detail.sectionId === raiz.dataset.seccionId) abrir();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (raiz && e.detail && e.detail.sectionId === raiz.dataset.seccionId) cerrar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-catalogo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.ctListo) return;
    raiz.dataset.ctListo = 'true';

    var orden = raiz.querySelector('[data-ct-orden]');
    if (orden) {
      orden.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', orden.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var items = raiz.querySelectorAll('[data-ct-item]');
    if (!raiz.classList.contains('catalogo-fizzo--animado') || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('catalogo-fizzo__item--visible'); });
      return;
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('catalogo-fizzo__item--visible');
          observador.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (i) { observador.observe(i); });
    setTimeout(function () {
      items.forEach(function (i) { i.classList.add('catalogo-fizzo__item--visible'); });
    }, 3000);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-catalogo-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-compat"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.cpListo) return;
    raiz.dataset.cpListo = 'true';
    var items = raiz.querySelectorAll('[data-cp-item]');
    function mostrarTodos() {
      items.forEach(function (i) { i.classList.add('compatibles-fizzo__item--visible'); });
    }
    if (!raiz.classList.contains('compatibles-fizzo--animado') || !('IntersectionObserver' in window)) {
      mostrarTodos();
      return;
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('compatibles-fizzo__item--visible');
          observador.unobserve(en.target);
        }
      });
    }, { threshold: 0.25 });
    items.forEach(function (i) { observador.observe(i); });
    setTimeout(mostrarTodos, 4000);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-compatibles-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-compra"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.cfListo) return;
    raiz.dataset.cfListo = 'true';

    var pista = raiz.querySelector('[data-cf-pista]');
    var slides = pista ? pista.querySelectorAll('[data-cf-slide]') : [];
    var miniaturas = raiz.querySelectorAll('[data-cf-miniatura]');
    var prev = raiz.querySelector('[data-cf-prev]');
    var next = raiz.querySelector('[data-cf-next]');
    var actual = 0;
    var espera;

    function marcar(i) {
      actual = i;
      miniaturas.forEach(function (m, j) {
        m.classList.toggle('compra-fizzo__miniatura--activa', j === i);
        m.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    function ir(i) {
      if (!pista || !slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' });
      marcar(i);
    }

    if (pista) {
      pista.addEventListener('scroll', function () {
        clearTimeout(espera);
        espera = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          if (i !== actual) marcar(i);
        }, 80);
      }, { passive: true });
    }
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (next) next.addEventListener('click', function () { ir(actual + 1); });
    miniaturas.forEach(function (m) {
      m.addEventListener('click', function () { ir(parseInt(m.dataset.index, 10) || 0); });
    });

    var inputs = raiz.querySelectorAll('[data-cf-pack-input]');
    var idInput = raiz.querySelector('[data-cf-id]');
    var cantidadInput = raiz.querySelector('[data-cf-cantidad]');
    var boton = raiz.querySelector('[data-cf-boton]');
    var botonTexto = raiz.querySelector('[data-cf-boton-texto]');
    var aviso = raiz.querySelector('[data-cf-aviso]');
    var avisoTexto = raiz.querySelector('[data-cf-aviso-texto]');
    var avisoBarra = raiz.querySelector('[data-cf-aviso-barra]');
    var avisoRelleno = raiz.querySelector('[data-cf-aviso-relleno]');

    function actualizarAviso(input) {
      if (!aviso || !avisoTexto || aviso.dataset.modo !== 'stock_shopify') return;
      var cantidad = parseInt(input.dataset.stock, 10);
      var total = parseInt(aviso.dataset.total, 10) || 0;
      if (!isNaN(cantidad) && cantidad > 0) {
        avisoTexto.textContent = (aviso.dataset.plantilla || '').replace('[cantidad]', cantidad);
        if (avisoBarra && avisoRelleno && total > 0) {
          avisoBarra.hidden = false;
          avisoRelleno.style.width = Math.min(100, Math.round(cantidad * 100 / total)) + '%';
        }
      } else {
        avisoTexto.textContent = aviso.dataset.tituloBase || '';
        if (avisoBarra) avisoBarra.hidden = true;
      }
    }

    function aplicar(input) {
      raiz.querySelectorAll('[data-cf-pack]').forEach(function (p) {
        p.classList.remove('compra-fizzo__pack--activo');
      });
      var pack = input.closest('[data-cf-pack]');
      if (pack) pack.classList.add('compra-fizzo__pack--activo');
      if (idInput && input.dataset.variante) idInput.value = input.dataset.variante;
      if (cantidadInput) cantidadInput.value = input.dataset.cantidad || 1;
      var disponible = input.dataset.disponible !== 'false';
      if (botonTexto) botonTexto.textContent = disponible ? input.dataset.boton : botonTexto.dataset.agotado;
      if (boton && idInput && idInput.value) boton.disabled = !disponible;
      actualizarAviso(input);
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () { aplicar(input); });
      if (input.checked) aplicar(input);
    });

    var minis = Array.prototype.slice.call(raiz.querySelectorAll('[data-cf-video-mini]'));
    minis.forEach(function (mini) {
      var video = mini.querySelector('[data-cf-video-mini-video]');
      var toque = mini.querySelector('[data-cf-video-mini-toque]');
      if (!video || !toque) return;
      video.muted = true;
      toque.addEventListener('click', function () {
        if (video.paused) {
          mini.dataset.cfPausaManual = '';
          mini.classList.remove('compra-fizzo__video-mini--pausado');
          var pr = video.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else {
          video.pause();
          mini.dataset.cfPausaManual = 'true';
          mini.classList.add('compra-fizzo__video-mini--pausado');
        }
      });
    });

    if (minis.length && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var mini = en.target;
          var video = mini.querySelector('[data-cf-video-mini-video]');
          if (!video) return;
          if (en.isIntersecting) {
            if (mini.dataset.cfPausaManual !== 'true') {
              var pr = video.play();
              if (pr && pr.catch) pr.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.3 });
      minis.forEach(function (m) { observador.observe(m); });
    }
  }

  var SELECTOR_BOTONES = [
    '.hero-fizzo__boton',
    '.comparativa-fizzo__boton',
    '.preguntas-fizzo__boton',
    '.pasos-fizzo__boton',
    '.encabezado-fizzo__drawer-cta',
    '.encabezado-fizzo__enlace-tienda',
    '.barra-anuncio__destacado--enlace',
    '.carrito-fizzo__pagar--vacio',
    'a[href$="#comprar"]',
    '[data-ir-compra]'
  ].join(', ');

  function alturaEncabezado() {
    var encabezado = document.querySelector('.seccion-encabezado-fizzo');
    if (!encabezado) return 0;
    var estilo = window.getComputedStyle(encabezado);
    if (estilo.position !== 'sticky' && estilo.position !== 'fixed') return 0;
    return encabezado.getBoundingClientRect().height;
  }

  function irACompra(raiz) {
    var esMobile = window.matchMedia('(max-width: 989px)').matches;
    var destino = esMobile ? raiz.dataset.destinoMobile : raiz.dataset.destinoDesktop;
    var objetivo = raiz;
    if (destino === 'titulo') objetivo = raiz.querySelector('[data-cf-destino-titulo]') || raiz;
    if (destino === 'packs') objetivo = raiz.querySelector('[data-cf-destino-packs]') || raiz;
    var margen = destino === 'seccion' ? 0 : 16;
    var y = objetivo.getBoundingClientRect().top + window.scrollY - alturaEncabezado() - margen;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (raiz.dataset.resaltar === 'true' && !reduce) {
      raiz.classList.remove('compra-fizzo--resaltar');
      setTimeout(function () {
        raiz.classList.add('compra-fizzo--resaltar');
        setTimeout(function () { raiz.classList.remove('compra-fizzo--resaltar'); }, 1300);
      }, 750);
    }
  }

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest(SELECTOR_BOTONES);
    if (!enlace) return;
    var raiz = document.querySelector('[data-compra-fizzo]');
    if (!raiz || raiz.dataset.scroll !== 'true') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    e.stopPropagation();
    var cerrarCarrito = document.querySelector('.carrito-fizzo--abierto [data-cc-cerrar]');
    if (cerrarCarrito) cerrarCarrito.click();
    var cerrarMenu = document.querySelector('.encabezado-fizzo--menu-abierto [data-ef-cerrar-menu]');
    if (cerrarMenu) cerrarMenu.click();
    setTimeout(function () { irACompra(raiz); }, cerrarCarrito || cerrarMenu ? 320 : 0);
  }, true);

  function iniciarTodos() {
    document.querySelectorAll('[data-compra-fizzo]').forEach(iniciar);
    if (window.location.hash === '#comprar') {
      var raiz = document.querySelector('[data-compra-fizzo]');
      if (raiz) setTimeout(function () { irACompra(raiz); }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-encabezado"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.efListo) return;
    raiz.dataset.efListo = 'true';

    var envoltorio = raiz.closest('.shopify-section') || raiz;
    var abrirMenu = raiz.querySelector('[data-ef-abrir-menu]');
    var drawer = raiz.querySelector('[data-ef-drawer]');
    var cerrarMenu = raiz.querySelectorAll('[data-ef-cerrar-menu]');
    var abrirBuscador = raiz.querySelector('[data-ef-abrir-buscador]');
    var buscador = raiz.querySelector('[data-ef-buscador]');
    var inputBuscador = raiz.querySelector('[data-ef-buscador-input]');
    var contador = raiz.querySelector('[data-ef-contador]');

    function menu(abrir) {
      raiz.classList.toggle('encabezado-fizzo--menu-abierto', abrir);
      document.documentElement.style.overflow = abrir ? 'hidden' : '';
      if (abrirMenu) abrirMenu.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (drawer) drawer.setAttribute('aria-hidden', abrir ? 'false' : 'true');
      if (!abrir && abrirMenu) abrirMenu.focus();
    }

    function busqueda(abrir) {
      if (!buscador) return;
      buscador.hidden = !abrir;
      if (abrirBuscador) abrirBuscador.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (abrir && inputBuscador) inputBuscador.focus();
    }

    if (abrirMenu) abrirMenu.addEventListener('click', function () { menu(true); });
    cerrarMenu.forEach(function (el) { el.addEventListener('click', function () { menu(false); }); });
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { menu(false); });
      });
    }
    if (abrirBuscador) {
      abrirBuscador.addEventListener('click', function () { busqueda(buscador.hidden); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (raiz.classList.contains('encabezado-fizzo--menu-abierto')) menu(false);
      if (buscador && !buscador.hidden) busqueda(false);
    });

    document.addEventListener('click', function (e) {
      if (!buscador || buscador.hidden) return;
      if (!buscador.contains(e.target) && !(abrirBuscador && abrirBuscador.contains(e.target))) busqueda(false);
    });

    function revisarPegado() {
      var pegado = window.scrollY > 0 && envoltorio.getBoundingClientRect().top <= 0;
      raiz.classList.toggle('encabezado-fizzo--pegado', pegado);
    }
    window.addEventListener('scroll', revisarPegado, { passive: true });
    revisarPegado();

    function actualizarContador() {
      if (!contador) return;
      var ruta = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
      fetch(ruta, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          contador.textContent = carrito.item_count;
          contador.classList.toggle('encabezado-fizzo__contador--vacio', carrito.item_count === 0);
        })
        .catch(function () {});
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, actualizarContador);
    }
    document.addEventListener('cart:updated', actualizarContador);
    window.addEventListener('pageshow', function (e) { if (e.persisted) actualizarContador(); });
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-encabezado-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-pasos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.pzListo) return;
    raiz.dataset.pzListo = 'true';
    if (!raiz.classList.contains('pasos-fizzo--animado') || !('IntersectionObserver' in window)) {
      raiz.classList.add('pasos-fizzo--visible');
      return;
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          raiz.classList.add('pasos-fizzo--visible');
          observador.disconnect();
        }
      });
    }, { threshold: 0.15 });
    observador.observe(raiz);
    setTimeout(function () { raiz.classList.add('pasos-fizzo--visible'); }, 4000);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-pasos-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-preguntas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.pfListo) return;
    raiz.dataset.pfListo = 'true';
    if (raiz.dataset.unoAbierto !== 'true') return;
    var items = raiz.querySelectorAll('[data-pf-item]');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (otro) {
          if (otro !== item && otro.open) otro.open = false;
        });
      });
    });
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-preguntas-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-que-saca"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.sfListo) return;
    raiz.dataset.sfListo = 'true';
    var tarjetas = raiz.querySelectorAll('[data-sf-tarjeta]');
    if (!raiz.classList.contains('saca-fizzo--animado') || !('IntersectionObserver' in window)) {
      tarjetas.forEach(function (t) { t.classList.add('saca-fizzo__tarjeta--visible'); });
      return;
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('saca-fizzo__tarjeta--visible');
          observador.unobserve(en.target);
        }
      });
    }, { threshold: 0.2 });
    tarjetas.forEach(function (t) { observador.observe(t); });
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-saca-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-rasca"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_JUGADA = 'fizzo-rasca-jugada';
  var CLAVE_CERRADA = 'fizzo-rasca-cerrada';
  var CLAVE_FLOTANTE = 'fizzo-rasca-flotante-cerrado';

  function leer(clave, sesion) {
    try { return JSON.parse((sesion ? sessionStorage : localStorage).getItem(clave)); } catch (e) { return null; }
  }
  function guardar(clave, valor, sesion) {
    try { (sesion ? sessionStorage : localStorage).setItem(clave, JSON.stringify(valor)); } catch (e) {}
  }
  function escapar(texto) {
    return String(texto == null ? '' : texto).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function rutaRaiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function enSegundoPlano(url, opciones) {
    try {
      opciones = opciones || {};
      opciones.credentials = 'same-origin';
      opciones.redirect = 'manual';
      fetch(url, opciones).catch(function () {});
    } catch (e) {}
  }
  function aplicarDescuento(codigo) {
    if (!codigo) return;
    enSegundoPlano(rutaRaiz() + 'discount/' + encodeURIComponent(codigo));
  }
  function alturaEncabezado() {
    var encabezado = document.querySelector('.seccion-encabezado-fizzo');
    if (!encabezado) return 0;
    var posicion = window.getComputedStyle(encabezado).position;
    if (posicion !== 'sticky' && posicion !== 'fixed') return 0;
    return encabezado.getBoundingClientRect().height;
  }
  function irAOfertas(compra) {
    var destino = compra.querySelector('[data-cf-destino-packs]') || compra;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = destino.getBoundingClientRect().top + window.scrollY - alturaEncabezado() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (!reduce) {
      compra.classList.remove('compra-fizzo--resaltar');
      setTimeout(function () {
        compra.classList.add('compra-fizzo--resaltar');
        setTimeout(function () { compra.classList.remove('compra-fizzo--resaltar'); }, 1300);
      }, 800);
    }
  }

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.rsListo) return;
    raiz.dataset.rsListo = 'true';

    var premios = [];
    try { premios = JSON.parse(raiz.querySelector('[data-rs-premios]').textContent); } catch (e) { premios = []; }
    premios = premios.filter(function (p) { return p && (p.texto || p.grande); });
    if (premios.length < 2) return;

    var modal = raiz.querySelector('[data-rs-modal]');
    var overlay = raiz.querySelector('[data-rs-overlay]');
    var tarjeta = raiz.querySelector('[data-rs-tarjeta]');
    var lienzo = raiz.querySelector('[data-rs-lienzo]');
    var mano = raiz.querySelector('[data-rs-mano]');
    var premioGrande = raiz.querySelector('[data-rs-premio-grande]');
    var premioChico = raiz.querySelector('[data-rs-premio-chico]');
    var bajada = raiz.querySelector('[data-rs-bajada]');
    var inputNombre = raiz.querySelector('[data-rs-nombre]');
    var inputEmail = raiz.querySelector('[data-rs-email]');
    var inputAcepto = raiz.querySelector('[data-rs-acepto]');
    var errorEl = raiz.querySelector('[data-rs-error]');
    var botonDesbloquear = raiz.querySelector('[data-rs-desbloquear]');
    var botonRevelarYa = raiz.querySelector('[data-rs-revelar-ya]');
    var pasoForm = raiz.querySelector('[data-rs-paso="form"]');
    var pasoRascar = raiz.querySelector('[data-rs-paso="rascar"]');
    var pasoResultado = raiz.querySelector('[data-rs-paso="resultado"]');
    var tituloResultado = raiz.querySelector('[data-rs-resultado-titulo]');
    var textoResultado = raiz.querySelector('[data-rs-resultado-texto]');
    var cupon = raiz.querySelector('[data-rs-cupon]');
    var codigoEl = raiz.querySelector('[data-rs-codigo]');
    var copiar = raiz.querySelector('[data-rs-copiar]');
    var usar = raiz.querySelector('[data-rs-usar]');
    var flotante = raiz.querySelector('[data-rs-flotante]');
    var flotanteAbrir = raiz.querySelector('[data-rs-flotante-abrir]');
    var flotanteCerrar = raiz.querySelector('[data-rs-flotante-cerrar]');
    var flotanteTitulo = raiz.querySelector('[data-rs-flotante-titulo]');
    var flotanteSub = raiz.querySelector('[data-rs-flotante-sub]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var enEditor = !!(window.Shopify && window.Shopify.designMode);
    var autoAplicar = raiz.dataset.autoaplicar === 'true';
    var pedirNombre = raiz.dataset.pedirNombre === 'true' && !!inputNombre;
    var ctx = lienzo.getContext('2d');
    var foil = document.createElement('canvas');
    var foilCtx = foil.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var abierta = false;
    var disparada = false;
    var flotantePermitido = false;
    var desbloqueada = false;
    var revelada = false;
    var empezoARascar = false;
    var rascando = false;
    var ultimo = null;
    var ultimoCalculo = 0;
    var premioActual = null;
    var demo = { activo: false, raf: 0, timers: [] };

    function nombrePremio(p) {
      if (p.texto) return p.texto;
      return [p.grande, p.chico].filter(Boolean).join(' ');
    }

    function sortear() {
      var total = premios.reduce(function (t, p) { return t + Math.max(1, Number(p.peso) || 1); }, 0);
      var azar = Math.random() * total;
      for (var i = 0; i < premios.length; i++) {
        azar -= Math.max(1, Number(premios[i].peso) || 1);
        if (azar < 0) return i;
      }
      return premios.length - 1;
    }

    function prepararPremio() {
      if (premioActual) return;
      var previa = leer(CLAVE_JUGADA);
      if (previa && !enEditor) {
        premioActual = previa;
      } else {
        var p = premios[sortear()];
        premioActual = { nombre: nombrePremio(p), grande: p.grande, chico: p.chico, texto: p.texto, codigo: p.codigo || '', revelada: false };
      }
      ponerPremioEnTarjeta(premioActual);
    }

    function ponerPremioEnTarjeta(premio) {
      premioGrande.textContent = premio.grande || premio.nombre || premio.texto || '';
      premioChico.textContent = premio.grande ? (premio.chico || '') : '';
    }

    function pintarFoil() {
      var w = foil.width;
      var h = foil.height;
      foilCtx.clearRect(0, 0, w, h);
      var g = foilCtx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, raiz.dataset.foil1 || '#C9C2E8');
      g.addColorStop(0.5, raiz.dataset.foil2 || '#F3F0FF');
      g.addColorStop(1, raiz.dataset.foil1 || '#C9C2E8');
      foilCtx.fillStyle = g;
      foilCtx.fillRect(0, 0, w, h);
      foilCtx.save();
      foilCtx.globalAlpha = 0.1;
      foilCtx.strokeStyle = raiz.dataset.foilTexto || '#3B16C9';
      foilCtx.lineWidth = 2 * dpr;
      for (var x = -h; x < w; x += 14 * dpr) {
        foilCtx.beginPath();
        foilCtx.moveTo(x, h);
        foilCtx.lineTo(x + h, 0);
        foilCtx.stroke();
      }
      foilCtx.restore();
      var colorBurbuja = raiz.dataset.foilBurbujas || '#FF2D87';
      [[0.1, 0.2, 0.06], [0.9, 0.18, 0.045], [0.86, 0.82, 0.08], [0.08, 0.84, 0.035]].forEach(function (b) {
        foilCtx.beginPath();
        foilCtx.arc(b[0] * w, b[1] * h, b[2] * w, 0, Math.PI * 2);
        foilCtx.fillStyle = colorBurbuja;
        foilCtx.globalAlpha = 0.3;
        foilCtx.fill();
      });
      foilCtx.globalAlpha = 1;
      foilCtx.fillStyle = raiz.dataset.foilTexto || '#3B16C9';
      foilCtx.textAlign = 'center';
      foilCtx.textBaseline = 'middle';
      foilCtx.font = '800 ' + Math.round(Math.min(w * 0.1, 34 * dpr)) + "px 'Bricolage Grotesque', 'Trebuchet MS', sans-serif";
      foilCtx.fillText(raiz.dataset.foilLeyenda || 'RASCÁ ACÁ', w / 2, h * 0.4);
    }

    function copiarFoil() {
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, lienzo.width, lienzo.height);
      ctx.drawImage(foil, 0, 0);
      ctx.restore();
    }

    function dibujarFoil() {
      var r = tarjeta.getBoundingClientRect();
      if (!r.width) return;
      lienzo.width = foil.width = Math.round(r.width * dpr);
      lienzo.height = foil.height = Math.round(r.height * dpr);
      pintarFoil();
      copiarFoil();
    }

    function restaurarFoilSuave(fin) {
      var pasos = 8;
      function paso() {
        if (!demo.activo) return;
        ctx.save();
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 0.28;
        ctx.drawImage(foil, 0, 0);
        ctx.restore();
        pasos--;
        if (pasos > 0) {
          demo.raf = requestAnimationFrame(paso);
        } else {
          copiarFoil();
          if (fin) fin();
        }
      }
      demo.raf = requestAnimationFrame(paso);
    }

    function caminoDemo(t) {
      var w = lienzo.width;
      var h = lienzo.height;
      return {
        x: w * (0.16 + 0.68 * t),
        y: h * (0.6 + 0.13 * Math.sin(t * Math.PI * 2.4))
      };
    }

    function moverMano(p, presion) {
      if (!mano) return;
      var anchoMano = mano.offsetWidth || 44;
      var altoMano = mano.offsetHeight || 52;
      var x = p.x / dpr - anchoMano * 0.44;
      var y = p.y / dpr - altoMano * 0.04;
      mano.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(-14deg) scale(' + presion + ')';
    }

    function demoPuede() {
      return raiz.dataset.demo === 'true' && !reduce && abierta && !empezoARascar && !revelada && lienzo.width > 0;
    }

    function temporizador(fn, ms) {
      demo.timers.push(setTimeout(fn, ms));
    }

    function cicloDemo() {
      if (!demoPuede()) { detenerDemo(); return; }
      var inicio = null;
      var anterior = null;
      var duracion = 1900;
      var radio = (parseInt(raiz.dataset.pincel, 10) || 24) * dpr;
      var intensidad = (parseInt(raiz.dataset.demoIntensidad, 10) || 35) / 100;
      moverMano(caminoDemo(0), 1.12);
      mano.classList.add('rasca-fizzo__mano--visible');
      temporizador(function () {
        function cuadro(ts) {
          if (!demo.activo) return;
          if (!inicio) inicio = ts;
          var t = Math.min(1, (ts - inicio) / duracion);
          var suave = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
          var p = caminoDemo(suave);
          ctx.save();
          ctx.globalCompositeOperation = 'destination-out';
          ctx.globalAlpha = intensidad;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.lineWidth = radio * 1.6;
          ctx.beginPath();
          ctx.moveTo((anterior || p).x - 0.1, (anterior || p).y - 0.1);
          ctx.lineTo(p.x, p.y);
          ctx.stroke();
          ctx.restore();
          anterior = p;
          moverMano(p, 1);
          if (t < 1) {
            demo.raf = requestAnimationFrame(cuadro);
          } else {
            mano.classList.remove('rasca-fizzo__mano--visible');
            temporizador(function () {
              restaurarFoilSuave(function () { temporizador(cicloDemo, 1100); });
            }, 650);
          }
        }
        demo.raf = requestAnimationFrame(cuadro);
      }, 280);
    }

    function iniciarDemo() {
      if (demo.activo || !demoPuede()) return;
      demo.activo = true;
      cicloDemo();
    }

    function detenerDemo() {
      demo.activo = false;
      cancelAnimationFrame(demo.raf);
      demo.timers.forEach(clearTimeout);
      demo.timers = [];
      if (mano) mano.classList.remove('rasca-fizzo__mano--visible');
      if (!empezoARascar && !revelada && lienzo.width) copiarFoil();
    }

    function porcentajeRascado() {
      try {
        var datos = ctx.getImageData(0, 0, lienzo.width, lienzo.height).data;
        var paso = 32;
        var total = 0;
        var limpios = 0;
        for (var i = 3; i < datos.length; i += 4 * paso) {
          total++;
          if (datos[i] < 40) limpios++;
        }
        return total ? (limpios / total) * 100 : 0;
      } catch (e) {
        return 0;
      }
    }

    function punto(e) {
      var r = lienzo.getBoundingClientRect();
      return { x: (e.clientX - r.left) * dpr, y: (e.clientY - r.top) * dpr };
    }

    function rascarHasta(p) {
      var radio = (parseInt(raiz.dataset.pincel, 10) || 24) * dpr;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = 1;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = radio * 2;
      ctx.beginPath();
      if (ultimo) {
        ctx.moveTo(ultimo.x, ultimo.y);
      } else {
        ctx.moveTo(p.x - 0.1, p.y - 0.1);
      }
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      ctx.restore();
      ultimo = p;
    }

    function revisarAvance(forzar) {
      var ahora = Date.now();
      if (!forzar && ahora - ultimoCalculo < 160) return;
      ultimoCalculo = ahora;
      var umbral = parseInt(raiz.dataset.umbral, 10) || 50;
      if (porcentajeRascado() >= umbral) revelar(true);
    }

    lienzo.addEventListener('pointerdown', function (e) {
      if (!desbloqueada || revelada) return;
      e.preventDefault();
      if (!empezoARascar) {
        detenerDemo();
        empezoARascar = true;
      }
      rascando = true;
      ultimo = null;
      try { lienzo.setPointerCapture(e.pointerId); } catch (err) {}
      rascarHasta(punto(e));
    });
    lienzo.addEventListener('pointermove', function (e) {
      if (!rascando) return;
      e.preventDefault();
      rascarHasta(punto(e));
      revisarAvance(false);
    });
    function soltar() {
      if (!rascando) return;
      rascando = false;
      ultimo = null;
      revisarAvance(true);
    }
    lienzo.addEventListener('pointerup', soltar);
    lienzo.addEventListener('pointercancel', soltar);
    lienzo.addEventListener('pointerleave', soltar);

    function flotanteDescartado() {
      var dias = parseInt(raiz.dataset.pestanaOcultar, 10) || 0;
      if (dias === 0) return !!leer(CLAVE_FLOTANTE, true);
      var marca = leer(CLAVE_FLOTANTE);
      return !!(marca && (Date.now() - marca) < dias * 86400000);
    }

    function actualizarFlotante() {
      if (!flotante) return;
      var jugada = leer(CLAVE_JUGADA);
      if (jugada && jugada.revelada && !enEditor) {
        if (flotanteTitulo) flotanteTitulo.textContent = flotanteAbrir.dataset.tituloJugado || '';
        if (flotanteSub) flotanteSub.textContent = (flotanteAbrir.dataset.subJugado || '').replace('[codigo]', jugada.codigo || '').replace('[premio]', jugada.nombre || '');
      }
    }

    function mostrarFlotante() {
      if (!flotante || raiz.dataset.pestana !== 'true' || abierta) return;
      if (!enEditor && flotanteDescartado()) return;
      actualizarFlotante();
      flotante.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { flotante.classList.add('rasca-fizzo__flotante--visible'); });
      });
    }

    function ocultarFlotante() {
      if (!flotante) return;
      flotante.classList.remove('rasca-fizzo__flotante--visible');
      flotante.hidden = true;
    }

    function mostrarPaso(paso) {
      [pasoForm, pasoRascar, pasoResultado].forEach(function (p) { p.hidden = p !== paso; });
      paso.classList.remove('rasca-fizzo__paso--entrando');
      void paso.offsetWidth;
      paso.classList.add('rasca-fizzo__paso--entrando');
    }

    function mostrarResultado(premio, celebrar) {
      var partes = (tituloResultado.dataset.plantilla || '[premio]').split('[premio]');
      tituloResultado.innerHTML = partes.map(escapar).join('<strong>' + escapar(premio.nombre) + '</strong>');
      textoResultado.textContent = autoAplicar && premio.codigo ? textoResultado.dataset.auto : textoResultado.dataset.manual;
      if (premio.codigo) {
        cupon.hidden = false;
        codigoEl.textContent = premio.codigo;
      } else {
        cupon.hidden = true;
      }
      if (bajada) bajada.hidden = true;
      mostrarPaso(pasoResultado);
      actualizarFlotante();
      if (celebrar && !reduce) {
        raiz.classList.remove('rasca-fizzo--gano');
        void raiz.offsetWidth;
        raiz.classList.add('rasca-fizzo--gano');
      }
      if (celebrar && !window.matchMedia('(min-width: 750px)').matches) {
        setTimeout(function () {
          modal.scrollTo({ top: Math.max(0, pasoResultado.offsetTop - 12), behavior: reduce ? 'auto' : 'smooth' });
        }, 120);
      }
    }

    function mostrarYaRevelada(jugada) {
      detenerDemo();
      premioActual = jugada;
      ponerPremioEnTarjeta(jugada);
      desbloqueada = true;
      revelada = true;
      empezoARascar = true;
      tarjeta.classList.remove('rasca-fizzo__tarjeta--bloqueada');
      lienzo.classList.add('rasca-fizzo__lienzo--revelado');
      mostrarResultado(jugada, false);
    }

    function revelar(celebrar) {
      if (revelada || !premioActual) return;
      detenerDemo();
      revelada = true;
      rascando = false;
      lienzo.classList.add('rasca-fizzo__lienzo--revelado');
      if (!enEditor) {
        premioActual.revelada = true;
        guardar(CLAVE_JUGADA, premioActual);
        if (autoAplicar) aplicarDescuento(premioActual.codigo);
      }
      setTimeout(function () { mostrarResultado(premioActual, celebrar); }, reduce ? 0 : 350);
    }

    function enviarDatos(nombre, email, etiquetas) {
      if (enEditor) return;
      var datos = new FormData();
      datos.append('form_type', 'customer');
      datos.append('utf8', '✓');
      datos.append('contact[email]', email);
      if (nombre) datos.append('contact[first_name]', nombre);
      datos.append('contact[tags]', etiquetas);
      enSegundoPlano(rutaRaiz() + 'contact', { method: 'POST', body: datos, headers: { Accept: 'text/html' } });
    }

    function mostrarError(texto, campo) {
      errorEl.textContent = texto || '';
      errorEl.hidden = !texto;
      [inputNombre, inputEmail].forEach(function (i) { if (i) i.classList.remove('rasca-fizzo__input--error'); });
      if (campo) {
        campo.classList.add('rasca-fizzo__input--error');
        if (campo.focus) campo.focus();
      }
    }

    function validar() {
      var nombre = pedirNombre ? (inputNombre.value || '').trim() : '';
      var email = (inputEmail.value || '').trim();
      if (pedirNombre && !nombre) {
        mostrarError(botonDesbloquear.dataset.errorNombre, inputNombre);
        return null;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        mostrarError(botonDesbloquear.dataset.errorEmail, inputEmail);
        return null;
      }
      if (!inputAcepto.checked) {
        mostrarError(botonDesbloquear.dataset.errorAcepto, null);
        return null;
      }
      mostrarError('', null);
      return { nombre: nombre, email: email };
    }

    function desbloquear() {
      if (desbloqueada) return;
      var previa = leer(CLAVE_JUGADA);
      if (previa && !enEditor) {
        if (previa.revelada) { mostrarYaRevelada(previa); return; }
        premioActual = previa;
      } else {
        var datos = validar();
        if (!datos) return;
        prepararPremio();
        premioActual.fecha = Date.now();
        premioActual.revelada = false;
        var etiquetas = raiz.dataset.etiquetas || 'rasca';
        if (premioActual.codigo) etiquetas += ', premio-' + premioActual.codigo;
        enviarDatos(datos.nombre, datos.email, etiquetas);
        if (!enEditor) guardar(CLAVE_JUGADA, premioActual);
      }
      ponerPremioEnTarjeta(premioActual);
      desbloqueada = true;
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      tarjeta.classList.remove('rasca-fizzo__tarjeta--bloqueada');
      if (!reduce) {
        tarjeta.classList.remove('rasca-fizzo__tarjeta--desbloqueando');
        void tarjeta.offsetWidth;
        tarjeta.classList.add('rasca-fizzo__tarjeta--desbloqueando');
      }
      mostrarPaso(pasoRascar);
      if (!window.matchMedia('(min-width: 750px)').matches) {
        setTimeout(function () {
          modal.scrollTo({ top: Math.max(0, tarjeta.offsetTop - 16), behavior: reduce ? 'auto' : 'smooth' });
        }, 80);
      }
    }

    botonDesbloquear.addEventListener('click', function (e) {
      e.preventDefault();
      desbloquear();
    });
    [inputNombre, inputEmail].forEach(function (input) {
      if (!input) return;
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (input === inputNombre) { inputEmail.focus(); } else { desbloquear(); }
        }
      });
    });
    if (botonRevelarYa) botonRevelarYa.addEventListener('click', function () { revelar(true); });

    copiar.addEventListener('click', function () {
      var texto = codigoEl.textContent;
      var original = copiar.textContent;
      function listo() {
        copiar.textContent = copiar.dataset.copiado;
        setTimeout(function () { copiar.textContent = original; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(listo).catch(listo);
      } else {
        listo();
      }
    });

    function abrir() {
      if (abierta) return;
      abierta = true;
      raiz.classList.add('rasca-fizzo--abierta');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      ocultarFlotante();
      var jugada = leer(CLAVE_JUGADA);
      if (jugada && jugada.revelada && !enEditor) {
        mostrarYaRevelada(jugada);
        return;
      }
      if (!empezoARascar && !revelada) {
        prepararPremio();
        requestAnimationFrame(function () {
          var listo = function () {
            dibujarFoil();
            setTimeout(iniciarDemo, 700);
          };
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(listo);
          } else {
            listo();
          }
        });
      }
    }

    function cerrar() {
      if (!abierta) return;
      abierta = false;
      rascando = false;
      detenerDemo();
      raiz.classList.remove('rasca-fizzo--abierta');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (!enEditor && !leer(CLAVE_JUGADA)) guardar(CLAVE_CERRADA, Date.now());
      if (raiz.dataset.pestanaTrasCerrar === 'true' || flotantePermitido) {
        flotantePermitido = true;
        setTimeout(mostrarFlotante, 400);
      }
    }

    usar.addEventListener('click', function (e) {
      var jugada = leer(CLAVE_JUGADA);
      if (jugada && jugada.codigo && !autoAplicar) aplicarDescuento(jugada.codigo);
      var compra = document.querySelector('[data-compra-fizzo]');
      if (!compra) return;
      e.preventDefault();
      e.stopPropagation();
      cerrar();
      setTimeout(function () { irAOfertas(compra); }, 420);
    });

    raiz.querySelectorAll('[data-rs-cerrar]').forEach(function (el) { el.addEventListener('click', cerrar); });
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (desbloqueada) return;
        cerrar();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierta) cerrar(); });

    var esperaResize;
    window.addEventListener('resize', function () {
      if (!abierta || empezoARascar || revelada) return;
      clearTimeout(esperaResize);
      esperaResize = setTimeout(function () {
        detenerDemo();
        dibujarFoil();
        setTimeout(iniciarDemo, 400);
      }, 200);
    });

    if (flotanteAbrir) flotanteAbrir.addEventListener('click', abrir);
    if (flotanteCerrar) {
      flotanteCerrar.addEventListener('click', function (e) {
        e.stopPropagation();
        ocultarFlotante();
        flotantePermitido = false;
        if (enEditor) return;
        var dias = parseInt(raiz.dataset.pestanaOcultar, 10) || 0;
        if (dias === 0) { guardar(CLAVE_FLOTANTE, Date.now(), true); } else { guardar(CLAVE_FLOTANTE, Date.now()); }
      });
    }

    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === raiz.dataset.seccionId) abrir();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === raiz.dataset.seccionId) cerrar();
    });

    if (enEditor) {
      if (raiz.dataset.pestana === 'true') mostrarFlotante();
      return;
    }

    var jugada = leer(CLAVE_JUGADA);
    if (jugada && jugada.revelada) mostrarYaRevelada(jugada);

    var demoraFlotante = parseInt(raiz.dataset.pestanaDemora, 10) || 0;
    setTimeout(function () {
      flotantePermitido = true;
      mostrarFlotante();
    }, demoraFlotante * 1000);

    if (raiz.dataset.activo !== 'true' || jugada) return;

    var cerrada = leer(CLAVE_CERRADA);
    var frecuencia = parseInt(raiz.dataset.frecuencia, 10) || 0;
    if (cerrada && frecuencia > 0 && (Date.now() - cerrada) < frecuencia * 86400000) return;

    var esDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (!esDesktop && raiz.dataset.soloPestanaMobile === 'true') return;
    if (esDesktop && raiz.dataset.desktop !== 'true') return;
    if (!esDesktop && raiz.dataset.mobile !== 'true') return;

    function disparar() {
      if (disparada) return;
      disparada = true;
      abrir();
    }

    var demora = parseInt(raiz.dataset.demora, 10) || 0;
    var scroll = parseInt(raiz.dataset.scroll, 10) || 0;
    var salida = raiz.dataset.salida === 'true';
    var hayDisparador = false;

    if (demora > 0) {
      hayDisparador = true;
      setTimeout(disparar, demora * 1000);
    }
    if (scroll > 0) {
      hayDisparador = true;
      window.addEventListener('scroll', function alBajar() {
        var total = document.documentElement.scrollHeight - window.innerHeight;
        if (total > 0 && (window.scrollY / total) * 100 >= scroll) {
          window.removeEventListener('scroll', alBajar);
          disparar();
        }
      }, { passive: true });
    }
    if (salida && esDesktop) {
      hayDisparador = true;
      document.addEventListener('mouseout', function alSalir(e) {
        if (!e.relatedTarget && e.clientY <= 0) {
          document.removeEventListener('mouseout', alSalir);
          disparar();
        }
      });
    }
    if (!hayDisparador) setTimeout(disparar, 800);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-rasca-fizzo]').forEach(function (r) {
      try { iniciar(r); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-resenas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.rsListo) return;
    raiz.dataset.rsListo = 'true';

    var pista = raiz.querySelector('[data-rs-pista]');
    var prev = raiz.querySelector('[data-rs-prev]');
    var next = raiz.querySelector('[data-rs-next]');
    var visor = raiz.querySelector('[data-rs-visor]');
    var visorImg = raiz.querySelector('[data-rs-visor-img]');
    var visorCerrar = raiz.querySelector('[data-rs-visor-cerrar]');

    function paso() {
      var tarjeta = pista ? pista.querySelector('[data-rs-tarjeta]') : null;
      if (!tarjeta) return 300;
      var gap = parseFloat(getComputedStyle(pista).columnGap || getComputedStyle(pista).gap) || 0;
      return tarjeta.getBoundingClientRect().width + gap;
    }

    function actualizarFlechas() {
      if (!pista || !prev || !next) return;
      var max = pista.scrollWidth - pista.clientWidth - 2;
      prev.disabled = pista.scrollLeft <= 2;
      next.disabled = pista.scrollLeft >= max;
    }

    if (pista) {
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      pista.addEventListener('scroll', actualizarFlechas, { passive: true });
      window.addEventListener('resize', actualizarFlechas);
      actualizarFlechas();
    }

    function abrirVisor(src, alt) {
      if (!visor || !visorImg) return;
      visorImg.src = src;
      visorImg.alt = alt || '';
      visor.classList.add('resenas-fizzo__visor--abierto');
      visor.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (visorCerrar) visorCerrar.focus();
    }

    function cerrarVisor() {
      if (!visor) return;
      visor.classList.remove('resenas-fizzo__visor--abierto');
      visor.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    raiz.querySelectorAll('[data-rs-foto]').forEach(function (foto) {
      foto.addEventListener('click', function () { abrirVisor(foto.dataset.src, foto.dataset.alt); });
    });
    if (visor) {
      visor.addEventListener('click', function (e) {
        if (e.target === visor || e.target.closest('[data-rs-visor-cerrar]')) cerrarVisor();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && visor && visor.classList.contains('resenas-fizzo__visor--abierto')) cerrarVisor();
    });
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-resenas-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-ruleta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_JUGADA = 'fizzo-ruleta-jugada';
  var CLAVE_CERRADA = 'fizzo-ruleta-cerrada';
  var CLAVE_FLOTANTE = 'fizzo-ruleta-flotante-cerrado';

  function leer(clave, sesion) {
    try { return JSON.parse((sesion ? sessionStorage : localStorage).getItem(clave)); } catch (e) { return null; }
  }
  function guardar(clave, valor, sesion) {
    try { (sesion ? sessionStorage : localStorage).setItem(clave, JSON.stringify(valor)); } catch (e) {}
  }
  function escapar(texto) {
    return String(texto == null ? '' : texto).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function rutaRaiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function enSegundoPlano(url, opciones) {
    try {
      opciones = opciones || {};
      opciones.credentials = 'same-origin';
      opciones.redirect = 'manual';
      fetch(url, opciones).catch(function () {});
    } catch (e) {}
  }
  function aplicarDescuento(codigo) {
    if (!codigo) return;
    enSegundoPlano(rutaRaiz() + 'discount/' + encodeURIComponent(codigo));
  }
  function alturaEncabezado() {
    var encabezado = document.querySelector('.seccion-encabezado-fizzo');
    if (!encabezado) return 0;
    var posicion = window.getComputedStyle(encabezado).position;
    if (posicion !== 'sticky' && posicion !== 'fixed') return 0;
    return encabezado.getBoundingClientRect().height;
  }
  function irAOfertas(compra) {
    var destino = compra.querySelector('[data-cf-destino-packs]') || compra;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = destino.getBoundingClientRect().top + window.scrollY - alturaEncabezado() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (!reduce) {
      compra.classList.remove('compra-fizzo--resaltar');
      setTimeout(function () {
        compra.classList.add('compra-fizzo--resaltar');
        setTimeout(function () { compra.classList.remove('compra-fizzo--resaltar'); }, 1300);
      }, 800);
    }
  }

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.rlListo) return;
    raiz.dataset.rlListo = 'true';

    var premios = [];
    try { premios = JSON.parse(raiz.querySelector('[data-rl-premios]').textContent); } catch (e) { premios = []; }
    premios = premios.filter(function (p) { return p && (p.texto || p.grande); });
    if (premios.length < 2) return;

    var modal = raiz.querySelector('[data-rl-modal]');
    var overlay = raiz.querySelector('[data-rl-overlay]');
    var rueda = raiz.querySelector('[data-rl-rueda]');
    var svg = raiz.querySelector('[data-rl-svg]');
    var inputNombre = raiz.querySelector('[data-rl-nombre]');
    var inputEmail = raiz.querySelector('[data-rl-email]');
    var inputAcepto = raiz.querySelector('[data-rl-acepto]');
    var errorEl = raiz.querySelector('[data-rl-error]');
    var botonGirar = raiz.querySelector('[data-rl-girar]');
    var pasoForm = raiz.querySelector('[data-rl-paso="form"]');
    var pasoResultado = raiz.querySelector('[data-rl-paso="resultado"]');
    var tituloResultado = raiz.querySelector('[data-rl-resultado-titulo]');
    var textoResultado = raiz.querySelector('[data-rl-resultado-texto]');
    var cupon = raiz.querySelector('[data-rl-cupon]');
    var codigoEl = raiz.querySelector('[data-rl-codigo]');
    var copiar = raiz.querySelector('[data-rl-copiar]');
    var usar = raiz.querySelector('[data-rl-usar]');
    var flotante = raiz.querySelector('[data-rl-flotante]');
    var flotanteAbrir = raiz.querySelector('[data-rl-flotante-abrir]');
    var flotanteCerrar = raiz.querySelector('[data-rl-flotante-cerrar]');
    var flotanteTitulo = raiz.querySelector('[data-rl-flotante-titulo]');
    var flotanteSub = raiz.querySelector('[data-rl-flotante-sub]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var enEditor = !!(window.Shopify && window.Shopify.designMode);
    var autoAplicar = raiz.dataset.autoaplicar === 'true';
    var rotacion = 0;
    var abierta = false;
    var disparada = false;
    var girando = false;
    var flotantePermitido = false;

    var n = premios.length;
    var angulo = 360 / n;
    var c = 100;
    var rPorcion = 90;
    var html = '';
    premios.forEach(function (p, i) {
      var a0 = (i * angulo - 90) * Math.PI / 180;
      var a1 = ((i + 1) * angulo - 90) * Math.PI / 180;
      var x0 = c + rPorcion * Math.cos(a0);
      var y0 = c + rPorcion * Math.sin(a0);
      var x1 = c + rPorcion * Math.cos(a1);
      var y1 = c + rPorcion * Math.sin(a1);
      var arco = angulo > 180 ? 1 : 0;
      var medio = i * angulo + angulo / 2;
      var textoGrande = String(p.grande || p.texto || '');
      var textoChico = p.grande ? String(p.chico || '') : '';
      var base = n > 8 ? 12 : n > 6 ? 14 : 17;
      var tamGrande = textoGrande.length > 5 ? base * 0.62 : textoGrande.length > 3 ? base * 0.85 : base;
      var tamChico = n > 8 ? 6.5 : 8;
      html += '<path d="M' + c + ' ' + c + ' L' + x0.toFixed(2) + ' ' + y0.toFixed(2) + ' A' + rPorcion + ' ' + rPorcion + ' 0 ' + arco + ' 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2) + ' Z" fill="' + escapar(p.fondo || '#D6FF3D') + '" stroke="' + escapar(raiz.dataset.borde || '#1A0F3D') + '" stroke-width="1.2"/>';
      html += '<g transform="rotate(' + medio.toFixed(2) + ' 100 100)" fill="' + escapar(p.color || '#1A0F3D') + '" font-family="Bricolage Grotesque, Trebuchet MS, sans-serif" font-weight="800" text-anchor="middle">';
      html += '<text x="100" y="' + (textoChico ? 36 : 42) + '" font-size="' + tamGrande.toFixed(1) + '" letter-spacing="-0.3">' + escapar(textoGrande) + '</text>';
      if (textoChico) html += '<text x="100" y="' + (36 + tamChico + 3) + '" font-size="' + tamChico + '" font-family="Manrope, Arial, sans-serif" letter-spacing="0.8">' + escapar(textoChico) + '</text>';
      html += '</g>';
    });
    html += '<circle cx="100" cy="100" r="95" fill="none" stroke="' + escapar(raiz.dataset.aro || '#3B16C9') + '" stroke-width="10"/>';
    var luces = n * 2;
    for (var j = 0; j < luces; j++) {
      var al = (j * (360 / luces) - 90 + (180 / luces)) * Math.PI / 180;
      var lx = (c + 95 * Math.cos(al)).toFixed(2);
      var ly = (c + 95 * Math.sin(al)).toFixed(2);
      var colorLuz = j % 2 === 0 ? raiz.dataset.luz1 : raiz.dataset.luz2;
      html += '<circle cx="' + lx + '" cy="' + ly + '" r="2.6" fill="' + escapar(colorLuz || '#FFFFFF') + '" class="ruleta-fizzo__luz ruleta-fizzo__luz--' + (j % 2 === 0 ? 'a' : 'b') + '"/>';
    }
    svg.innerHTML = html;

    function nombrePremio(p) {
      if (p.texto) return p.texto;
      return [p.grande, p.chico].filter(Boolean).join(' ');
    }

    function flotanteDescartado() {
      var dias = parseInt(raiz.dataset.pestanaOcultar, 10) || 0;
      if (dias === 0) return !!leer(CLAVE_FLOTANTE, true);
      var marca = leer(CLAVE_FLOTANTE);
      return !!(marca && (Date.now() - marca) < dias * 86400000);
    }

    function actualizarFlotante() {
      if (!flotante) return;
      var jugada = leer(CLAVE_JUGADA);
      if (jugada && !enEditor) {
        if (flotanteTitulo) flotanteTitulo.textContent = flotanteAbrir.dataset.tituloJugado || '';
        if (flotanteSub) flotanteSub.textContent = (flotanteAbrir.dataset.subJugado || '').replace('[codigo]', jugada.codigo || '').replace('[premio]', jugada.nombre || '');
      }
    }

    function mostrarFlotante() {
      if (!flotante || raiz.dataset.pestana !== 'true' || abierta) return;
      if (!enEditor && flotanteDescartado()) return;
      actualizarFlotante();
      flotante.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { flotante.classList.add('ruleta-fizzo__flotante--visible'); });
      });
    }

    function ocultarFlotante() {
      if (!flotante) return;
      flotante.classList.remove('ruleta-fizzo__flotante--visible');
      flotante.hidden = true;
    }

    function mostrarResultado(premio, celebrar) {
      pasoForm.hidden = true;
      pasoResultado.hidden = false;
      var partes = (tituloResultado.dataset.plantilla || '[premio]').split('[premio]');
      tituloResultado.innerHTML = partes.map(escapar).join('<strong>' + escapar(premio.nombre) + '</strong>');
      textoResultado.textContent = autoAplicar && premio.codigo ? textoResultado.dataset.auto : textoResultado.dataset.manual;
      if (premio.codigo) {
        cupon.hidden = false;
        codigoEl.textContent = premio.codigo;
      } else {
        cupon.hidden = true;
      }
      actualizarFlotante();
      if (celebrar) {
        pasoResultado.classList.remove('ruleta-fizzo__paso--entrando');
        void pasoResultado.offsetWidth;
        pasoResultado.classList.add('ruleta-fizzo__paso--entrando');
        if (!reduce) {
          raiz.classList.remove('ruleta-fizzo--gano');
          void raiz.offsetWidth;
          raiz.classList.add('ruleta-fizzo--gano');
        }
        if (!window.matchMedia('(min-width: 750px)').matches) {
          setTimeout(function () {
            modal.scrollTo({ top: Math.max(0, pasoResultado.offsetTop - 12), behavior: reduce ? 'auto' : 'smooth' });
          }, 80);
        }
      }
    }

    function abrir() {
      if (abierta) return;
      abierta = true;
      var jugada = leer(CLAVE_JUGADA);
      if (jugada && !enEditor && !girando) mostrarResultado(jugada, false);
      raiz.classList.add('ruleta-fizzo--abierta');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      ocultarFlotante();
    }

    function cerrar() {
      if (!abierta || girando) return;
      abierta = false;
      raiz.classList.remove('ruleta-fizzo--abierta');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (!enEditor && !leer(CLAVE_JUGADA)) guardar(CLAVE_CERRADA, Date.now());
      if (raiz.dataset.pestanaTrasCerrar === 'true' || flotantePermitido) {
        flotantePermitido = true;
        setTimeout(mostrarFlotante, 400);
      }
    }

    function sortear() {
      var total = premios.reduce(function (t, p) { return t + Math.max(1, Number(p.peso) || 1); }, 0);
      var azar = Math.random() * total;
      for (var i = 0; i < premios.length; i++) {
        azar -= Math.max(1, Number(premios[i].peso) || 1);
        if (azar < 0) return i;
      }
      return premios.length - 1;
    }

    function girar(indice, fin) {
      var medio = indice * angulo + angulo / 2;
      var vueltas = parseInt(raiz.dataset.vueltas, 10) || 6;
      var duracion = reduce ? 0.01 : (parseFloat(raiz.dataset.duracion) || 5);
      var jitter = (Math.random() - 0.5) * angulo * 0.5;
      var base = rotacion - (rotacion % 360);
      rotacion = base + vueltas * 360 + (360 - medio) + jitter;
      var terminado = false;
      function terminar() {
        if (terminado) return;
        terminado = true;
        rueda.removeEventListener('transitionend', alTerminar);
        fin();
      }
      function alTerminar(e) {
        if (e.target === rueda && e.propertyName === 'transform') terminar();
      }
      rueda.addEventListener('transitionend', alTerminar);
      rueda.style.transition = 'transform ' + duracion + 's cubic-bezier(0.22, 0.12, 0.12, 1)';
      requestAnimationFrame(function () {
        rueda.style.transform = 'rotate(' + rotacion + 'deg)';
      });
      setTimeout(terminar, duracion * 1000 + 400);
    }

    function enviarDatos(nombre, email, etiquetas) {
      if (enEditor) return;
      var datos = new FormData();
      datos.append('form_type', 'customer');
      datos.append('utf8', '✓');
      datos.append('contact[email]', email);
      if (nombre) datos.append('contact[first_name]', nombre);
      datos.append('contact[tags]', etiquetas);
      enSegundoPlano(rutaRaiz() + 'contact', { method: 'POST', body: datos, headers: { Accept: 'text/html' } });
    }

    function mostrarError(texto, campo) {
      if (!errorEl) return;
      errorEl.textContent = texto || '';
      errorEl.hidden = !texto;
      [inputNombre, inputEmail].forEach(function (i) { if (i) i.classList.remove('ruleta-fizzo__input--error'); });
      if (campo) {
        campo.classList.add('ruleta-fizzo__input--error');
        if (campo.focus) campo.focus();
      }
    }

    function validar() {
      var nombre = (inputNombre.value || '').trim();
      var email = (inputEmail.value || '').trim();
      if (raiz.dataset.nombreObligatorio === 'true' && !nombre) {
        mostrarError(botonGirar.dataset.errorNombre, inputNombre);
        return null;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        mostrarError(botonGirar.dataset.errorEmail, inputEmail);
        return null;
      }
      if (!inputAcepto.checked) {
        mostrarError(botonGirar.dataset.errorAcepto, null);
        return null;
      }
      mostrarError('', null);
      return { nombre: nombre, email: email };
    }

    function jugar() {
      if (girando) return;
      var previa = leer(CLAVE_JUGADA);
      if (previa && !enEditor) { mostrarResultado(previa, false); return; }
      var datos = validar();
      if (!datos) return;
      var indice = sortear();
      var premio = premios[indice];
      var resultado = { nombre: nombrePremio(premio), codigo: premio.codigo || '', fecha: Date.now() };
      girando = true;
      raiz.classList.add('ruleta-fizzo--girando');
      botonGirar.disabled = true;
      botonGirar.textContent = botonGirar.dataset.girando;
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      var etiquetas = raiz.dataset.etiquetas || 'ruleta';
      if (resultado.codigo) etiquetas += ', premio-' + resultado.codigo;
      enviarDatos(datos.nombre, datos.email, etiquetas);
      if (!enEditor) guardar(CLAVE_JUGADA, resultado);
      girar(indice, function () {
        girando = false;
        raiz.classList.remove('ruleta-fizzo--girando');
        if (!enEditor && autoAplicar) aplicarDescuento(resultado.codigo);
        mostrarResultado(resultado, true);
      });
    }

    botonGirar.addEventListener('click', function (e) {
      e.preventDefault();
      jugar();
    });
    [inputNombre, inputEmail].forEach(function (input) {
      if (!input) return;
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (input === inputNombre) { inputEmail.focus(); } else { jugar(); }
        }
      });
    });

    copiar.addEventListener('click', function () {
      var texto = codigoEl.textContent;
      var original = copiar.textContent;
      function listo() {
        copiar.textContent = copiar.dataset.copiado;
        setTimeout(function () { copiar.textContent = original; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(listo).catch(listo);
      } else {
        listo();
      }
    });

    usar.addEventListener('click', function (e) {
      var jugada = leer(CLAVE_JUGADA);
      if (jugada && jugada.codigo && !autoAplicar) aplicarDescuento(jugada.codigo);
      var compra = document.querySelector('[data-compra-fizzo]');
      if (!compra) return;
      e.preventDefault();
      e.stopPropagation();
      cerrar();
      setTimeout(function () { irAOfertas(compra); }, 420);
    });

    raiz.querySelectorAll('[data-rl-cerrar]').forEach(function (el) { el.addEventListener('click', cerrar); });
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (girando || !pasoResultado.hidden) return;
        cerrar();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierta) cerrar(); });

    if (flotanteAbrir) flotanteAbrir.addEventListener('click', abrir);
    if (flotanteCerrar) {
      flotanteCerrar.addEventListener('click', function (e) {
        e.stopPropagation();
        ocultarFlotante();
        flotantePermitido = false;
        if (enEditor) return;
        var dias = parseInt(raiz.dataset.pestanaOcultar, 10) || 0;
        if (dias === 0) { guardar(CLAVE_FLOTANTE, Date.now(), true); } else { guardar(CLAVE_FLOTANTE, Date.now()); }
      });
    }

    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === raiz.dataset.seccionId) abrir();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === raiz.dataset.seccionId) cerrar();
    });

    if (enEditor) {
      if (raiz.dataset.pestana === 'true') mostrarFlotante();
      return;
    }

    var jugada = leer(CLAVE_JUGADA);
    if (jugada) mostrarResultado(jugada, false);

    var demoraFlotante = parseInt(raiz.dataset.pestanaDemora, 10) || 0;
    setTimeout(function () {
      flotantePermitido = true;
      mostrarFlotante();
    }, demoraFlotante * 1000);

    if (raiz.dataset.activo !== 'true' || jugada) return;

    var cerrada = leer(CLAVE_CERRADA);
    var frecuencia = parseInt(raiz.dataset.frecuencia, 10) || 0;
    if (cerrada && frecuencia > 0 && (Date.now() - cerrada) < frecuencia * 86400000) return;

    var esDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (!esDesktop && raiz.dataset.soloPestanaMobile === 'true') return;
    if (esDesktop && raiz.dataset.desktop !== 'true') return;
    if (!esDesktop && raiz.dataset.mobile !== 'true') return;

    function disparar() {
      if (disparada) return;
      disparada = true;
      abrir();
    }

    var demora = parseInt(raiz.dataset.demora, 10) || 0;
    var scroll = parseInt(raiz.dataset.scroll, 10) || 0;
    var salida = raiz.dataset.salida === 'true';
    var hayDisparador = false;

    if (demora > 0) {
      hayDisparador = true;
      setTimeout(disparar, demora * 1000);
    }
    if (scroll > 0) {
      hayDisparador = true;
      window.addEventListener('scroll', function alBajar() {
        var total = document.documentElement.scrollHeight - window.innerHeight;
        if (total > 0 && (window.scrollY / total) * 100 >= scroll) {
          window.removeEventListener('scroll', alBajar);
          disparar();
        }
      }, { passive: true });
    }
    if (salida && esDesktop) {
      hayDisparador = true;
      document.addEventListener('mouseout', function alSalir(e) {
        if (!e.relatedTarget && e.clientY <= 0) {
          document.removeEventListener('mouseout', alSalir);
          disparar();
        }
      });
    }
    if (!hayDisparador) setTimeout(disparar, 800);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-ruleta-fizzo]').forEach(function (r) {
      try { iniciar(r); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzo-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.dataset.vfListo) return;
    raiz.dataset.vfListo = 'true';

    var items = Array.prototype.slice.call(raiz.querySelectorAll('[data-vf-item]'));
    var animado = raiz.classList.contains('videos-fizzo--animado');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reversible = raiz.dataset.reversible === 'true';
    var duracion = (parseFloat(raiz.dataset.duracion) || 90) / 100;
    var pendiente = false;

    function actualizar() {
      pendiente = false;
      var vh = window.innerHeight;
      var inicio = vh * 0.9;
      var fin = inicio - vh * duracion;
      var progreso = (inicio - raiz.getBoundingClientRect().top) / (inicio - fin);
      if (progreso < 0) progreso = 0;
      if (progreso > 1) progreso = 1;
      var total = items.length;
      items.forEach(function (el, i) {
        var umbral = total > 1 ? (i / (total - 1)) * 0.92 + 0.02 : 0.02;
        if (progreso >= umbral) {
          el.classList.add('videos-fizzo__revelar--visible');
        } else if (reversible) {
          el.classList.remove('videos-fizzo__revelar--visible');
        }
      });
    }

    function pedir() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(actualizar);
    }

    if (!animado || reduce) {
      items.forEach(function (el) { el.classList.add('videos-fizzo__revelar--visible'); });
    } else {
      window.addEventListener('scroll', pedir, { passive: true });
      window.addEventListener('resize', pedir);
      actualizar();
    }

    var lista = raiz.querySelector('[data-vf-lista]');
    var tarjetas = Array.prototype.slice.call(raiz.querySelectorAll('[data-vf-tarjeta]'));
    var arrastrando = false;
    var movido = false;
    var x0 = 0;
    var s0 = 0;
    var punteroId = null;

    function paso() {
      if (tarjetas.length > 1) return tarjetas[1].offsetLeft - tarjetas[0].offsetLeft;
      return lista ? lista.clientWidth : 0;
    }

    if (lista) {
      lista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        arrastrando = true;
        movido = false;
        x0 = e.clientX;
        s0 = lista.scrollLeft;
        punteroId = e.pointerId;
      });
      lista.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        var dx = e.clientX - x0;
        if (!movido && Math.abs(dx) > 6) {
          movido = true;
          lista.classList.add('videos-fizzo__lista--arrastrando');
          try { lista.setPointerCapture(punteroId); } catch (err) {}
        }
        if (movido) {
          e.preventDefault();
          lista.scrollLeft = s0 - dx;
        }
      });
      function soltar() {
        if (!arrastrando) return;
        arrastrando = false;
        if (!movido) return;
        try { lista.releasePointerCapture(punteroId); } catch (err) {}
        var p = paso();
        if (p > 0) lista.scrollTo({ left: Math.round(lista.scrollLeft / p) * p, behavior: 'smooth' });
        setTimeout(function () {
          lista.classList.remove('videos-fizzo__lista--arrastrando');
          movido = false;
        }, 350);
      }
      lista.addEventListener('pointerup', soltar);
      lista.addEventListener('pointercancel', soltar);
      lista.addEventListener('pointerleave', soltar);
      lista.addEventListener('dragstart', function (e) { e.preventDefault(); });
      lista.addEventListener('click', function (e) {
        if (movido) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    var videos = Array.prototype.slice.call(raiz.querySelectorAll('[data-vf-video]'));
    var activo = null;

    function reproducir(v) {
      v.muted = true;
      v.loop = true;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var v = en.target;
          if (activo && activo.video === v) return;
          if (en.isIntersecting) {
            reproducir(v);
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { observador.observe(v); });
    } else {
      videos.forEach(reproducir);
    }

    var foco = raiz.querySelector('[data-vf-foco]');
    var marco = raiz.querySelector('[data-vf-foco-marco]');
    var cerrarBoton = raiz.querySelector('[data-vf-cerrar]');

    function abrir(tarjeta) {
      var v = tarjeta.querySelector('[data-vf-video]');
      if (!v || !foco || !marco) return;
      activo = { video: v, padre: v.parentNode, siguiente: v.nextSibling, tarjeta: tarjeta };
      marco.appendChild(v);
      try { v.currentTime = 0; } catch (err) {}
      reproducir(v);
      foco.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(function () { foco.classList.add('videos-fizzo__foco--abierto'); });
      if (cerrarBoton) cerrarBoton.focus();
    }

    function cerrar() {
      if (!activo) return;
      var v = activo.video;
      var tarjeta = activo.tarjeta;
      activo.padre.insertBefore(v, activo.siguiente);
      activo = null;
      reproducir(v);
      foco.classList.remove('videos-fizzo__foco--abierto');
      document.documentElement.style.overflow = '';
      setTimeout(function () { foco.hidden = true; }, 250);
      var boton = tarjeta.querySelector('[data-vf-abrir]');
      if (boton) boton.focus();
    }

    tarjetas.forEach(function (tarjeta) {
      var boton = tarjeta.querySelector('[data-vf-abrir]');
      if (boton) boton.addEventListener('click', function () { abrir(tarjeta); });
    });
    if (cerrarBoton) cerrarBoton.addEventListener('click', cerrar);
    if (foco) {
      foco.addEventListener('click', function (e) {
        if (e.target === foco) cerrar();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activo) cerrar();
    });
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-videos-fizzo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', iniciarTodos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
